import { AuthStatus, ReduxAction, ReduxState } from 'interfaces';
import { AUTH_STATUS, USER_DATA } from './actions';

export const initialState: ReduxState = {
    authStatus: AuthStatus.pending,
    userData: null,
};

function reducer(state: ReduxState = initialState, action: ReduxAction<any>): ReduxState {
    switch (action.type) {
        case USER_DATA:
            return { ...state, userData: action.payload };
        case AUTH_STATUS:
            return { ...state, authStatus: action.payload };
        default:
            return state;
    }
}

export default reducer;
